/**
 * Financial Management Routes
 *
 * Route definitions for the financial management module.
 */

import { lazy } from 'react';

const FinancialModule = lazy(() => import('./FinancialModule'));

export const financialRoutes = [
    {
        path: 'financials',
        element: <FinancialModule />,
    },
];
